import * as THREE from "three";
import { OrbitControls } from "./controls/OrbitControls";

export default class SceneOceanFixed extends THREE.Scene {
  constructor(player, config, repeat = false) {
    super();

    this.player = player;
    this.config = config;
    this.hotspots = [];
    const renderTargetParams = {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      format: THREE.RGBFormat,
      stencilBuffer: false,
    };
    /**
     * FBO for this scene
     */
    this.fbo = new THREE.WebGLRenderTarget(
      window.innerWidth,
      window.innerHeight,
      renderTargetParams,
    );

    //this.boat = new Boat(config, () => this.finishedLoad(), this);
    this.loadingCallback = player.loadingManager.start(!repeat);
    this.loadCount = 2;

    // Create camera that is only used in this scene
    this.camera = new THREE.PerspectiveCamera(
      55,
      window.innerWidth / window.innerHeight,
      1,
      20000,
    );
    const initialPosition = { x: 0, y: 55, z: -80 };

    this.camera.position.set(
      initialPosition.x,
      initialPosition.y,
      initialPosition.z,
    );
    this.camera.lookAt(0, 10, 0);

    // As we use a different camera, we need to handle resize here too
    this.onWindowResize.bind(this);
    window.addEventListener("resize", this.onWindowResize.bind(this), false);

    this.controls = new OrbitControls(this.camera, player.renderer.domElement);
    this.controls.mainCamera = this.camera;
    this.controls.maxPolarAngle = Math.PI * 0.495;
    this.controls.target.set(0, 10, 0);
    this.controls.minDistance = 0;
    this.controls.maxDistance = 200;
    this.controls.enablePan = false;
    this.controls.enableDamping = true;
    this.controls.enableRotate = false;
    this.controls.rotateSpeed = 1.0;
    this.camera.lookAt(this.controls.target);

    setTimeout(() => {
      this.finishedLoad();
    }, 250);
  }

  /**
   * This is triggered when window is resized.
   * It's used to change the camera aspect.
   * We already update the renderer in Player
   */
  onWindowResize() {
    const width = this.player.container.clientWidth;
    const height = this.player.container.clientHeight;

    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
  }

  /**
   * When an asset load is finished, call this.
   * This will hide the loading container
   */
  finishedLoad() {
    this.loadCount -= 1;

    if (this.loadCount === 0) {
      this.start();
      this.loadingCallback();
    }
  }

  /**
   * Simply renders the scene.
   */
  render(renderer, camera, useFbo) {
    // this.controls.update();
    if (useFbo) {
      renderer.render(this, this.camera, this.fbo, true);
    } else {
      renderer.render(this, this.camera);
    }
  }

  /**
   * Called just before deleting.
   * Used to clean up!
   */
  destroy() {
    window.removeEventListener("resize", this.onWindowResize.bind(this), false);
  }
  dispose() {}

  onMouseUp(event, mouse, camera) {
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, this.camera);

    // Check if any hotspots are hit
    const intersects = raycaster.intersectObjects(this.hotspots, true);

    if (intersects.length > 0) {
      const intersect = intersects[0];
      const object = intersects[0].object;
      const image = object.parent.getImage();
      intersect.position = intersect.point;

      const start = new THREE.Euler().copy(this.camera.rotation);
      this.camera.lookAt(intersect.point);
      const end = new THREE.Euler().copy(this.camera.rotation);
      this.camera.rotation.copy(start);

      if (Math.abs(start.z - end.z) > Math.PI) {
        if (start.z < end.z) {
          end.z -= Math.PI * 2;
        } else {
          end.z += Math.PI * 2;
        }
      }

      this.player.transitionTo(image, intersect, 1950);
    }
  }

  /**
   * Called every frame before render
   */
  update() {}

  /**
   * Start is called when load is complete and it's time to begin!
   */
  start() {}

  /**
   * Not currently used
   */
  startTransition() {}

  onMouseMove(event, mouse, camera) {
    // for (const hotspot of this.hotspots) {
    //     // if (hotspot.getOpacity() < 0.4) {
    //     //     return;
    //     // }
    //     // hotspot.setOpacity(1);
    // }
    // const raycaster = new THREE.Raycaster();
    // raycaster.setFromCamera(mouse, this.camera);
    // // Check if any hotspots are hit
    // const intersects = raycaster.intersectObjects(this.hotspots, true);
    // if (intersects.length > 0) {
    //     for (const intersect of intersects) {
    //         intersect.object.parent.setOpacity(0.7);
    //     }
    // }
  }

  static injectExample(tour) {
    tour.data.intro = {
      type: "ocean",
      model: `${window.location.origin}/tour/assets/tamsen.obj`,
      materials: `${window.location.origin}/tour/assets/tamsen.mtl`,
      decks: [
        {
          model: `${window.location.origin}/tour/assets/tamsen-deck.obj`,
          materials: `${window.location.origin}/tour/assets/tamsen-deck.mtl`,
          hotspots: [
            { x: -1.1067, y: 0.50503, z: 0, image: 683 },
            { x: 1.2367, y: 0.50503, z: 0, image: 717 },
            { x: -0.5067, y: 0.30503, z: 0, image: 659 },
          ],
        },
      ],
    };
  }
}
